import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Paper, Typography } from '@mui/material';
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import { IDENTIFIER_EXAMPLES, PASTE_ACTION } from '../shared/SheetPaste';

// The Watchlist's own words for pasting a sheet, and the empty Watchlist's
// hint. The paste listener and the Paste from Excel dialog are shared with
// the Actual Portfolio (see shared/SheetPaste.jsx).

export const PAGE_PASTE_HINT = 'Select a cell to paste values, or copy your sheet with a header row '
    + `that includes ${IDENTIFIER_EXAMPLES} to import it.`;
export const EMPTY_WATCHLIST_PASTE_HINT = 'Copy your sheet in Excel (with a header row) and '
    + `${PASTE_ACTION} here to import it.`;

/**
 * The empty Watchlist's invitation to paste a sheet, centred over the empty
 * rows of a positioned frame, below its `top` (the grid header).
 */
export function WatchlistEmptyPasteHint({ top = 0, onPaste }) {
    return (
        <Box
            data-testid="watchlist-empty-paste-hint"
            sx={{
                position: 'absolute',
                top,
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
                pointerEvents: 'none',
            }}
        >
            <Paper
                variant="outlined"
                sx={{
                    pointerEvents: 'auto',
                    maxWidth: 380,
                    px: 2.5,
                    py: 2,
                    display: 'grid',
                    justifyItems: 'center',
                    gap: 1.25,
                    textAlign: 'center',
                }}
            >
                <ContentPasteOutlinedIcon color="action" />
                <Typography variant="body2">{EMPTY_WATCHLIST_PASTE_HINT}</Typography>
                <Button
                    size="small"
                    variant="outlined"
                    startIcon={<ContentPasteOutlinedIcon fontSize="small" />}
                    onClick={onPaste}
                >
                    Paste from Excel
                </Button>
            </Paper>
        </Box>
    );
}

WatchlistEmptyPasteHint.propTypes = {
    top: PropTypes.number,
    onPaste: PropTypes.func.isRequired,
};
